// eslint-disable-next-line import/no-extraneous-dependencies
import moment from 'moment-timezone'

/** Order dates are stored in UTC; Ops read them in Sydney time as DD/MM/YYYY. */
export const formatSsccXmlDate = (value?: string | null) =>
  value ? moment.utc(value).tz('Australia/Sydney').format('DD/MM/YYYY') : ''
